const styles = () => ({
  grid: {
    marginTop: '16px',
  },
});

export default styles;
